module.exports = __webpack_public_path__ + "static/media/autoglass.0ef692f1.png";